(function SeoCategories($, Adzuki)
{
	"use strict";

	$(document).ready(function documentReady()
	{
		Adzuki.onload('SeoDealCategories/index', function onload() {
			$('.destination-container').click(function goToCategory() {
				document.location = Adzuki.base_uri + $(this).data('link');
			});
		});
	});
}(jQuery, window.Adzuki || {}));
